import React from 'react';
import { Box } from '@mui/material';
import BenevvPopupPoster from './BenevvPopupPoster';
import Masonry from '@mui/lab/Masonry';
import Typography from '@mui/material/Typography';

interface Poster {
  id: number;
  image: string;
  description: string;
}

interface BenevvPopupPostersProps {
  posters: Poster[];
  selectedItems: number[];
  handleSelect: (id: number) => void;
  emptyMessage?: string;
}

const BenevvPopupPosters = ({ 
  posters = [], 
  selectedItems = [], 
  handleSelect, 
  emptyMessage = "No posts to show" 
}: BenevvPopupPostersProps) => {
  if (posters.length === 0) {
    return (
      <Box 
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          minHeight: 300,
          padding: 3,
          marginTop: '-40px'
        }}
      >
        <Typography 
          variant="body1" 
          sx={{ 
            color: 'text.secondary',
            fontSize: 18,
          }}
        >
          {emptyMessage}
        </Typography>
      </Box>
    );
  }

  return (
    <Masonry columns={2} spacing={3} sx={{ paddingLeft: 2, paddingRight: 2 }}>
      {posters.map((poster: Poster) => (
        <Box key={poster.id} width="40%" marginBottom="8px" padding="0.5rem">
          <BenevvPopupPoster
            image={poster.image}
            description={poster.description}
            selected={selectedItems.includes(poster.id)}
            onClick={() => handleSelect(poster.id)}
          />
        </Box>
      ))}
    </Masonry>
  );
};

export default BenevvPopupPosters;
